<template>
    <div class="container">
        <h1 >IGEL</h1>
        <p class="lead">Short Documentary | 2019 | 12' | Color | 16:9 | German OS</p>

      <carousel per-page="1" navigation-enabled="true" autoplay="true" autoplay-timeout="7000">
        <slide>
          <img src="https://firebasestorage.googleapis.com/v0/b/anton-von-heiseler.appspot.com/o/mountainandmaiden%2F01.jpg?alt=media&token=8ec0180c-0288-4032-88d5-1bc27f879529" class="d-block w-100">
        </slide>
        <slide>
          <img src="https://firebasestorage.googleapis.com/v0/b/anton-von-heiseler.appspot.com/o/mountainandmaiden%2F03.jpg?alt=media&token=67d164f6-054f-4b2b-8a0a-8ec95c184544" class="d-block w-100" alt="...">
        </slide>
        <slide>
          <img src="https://firebasestorage.googleapis.com/v0/b/anton-von-heiseler.appspot.com/o/mountainandmaiden%2F04.jpg?alt=media&token=66466689-4408-48b7-903a-bd635dda7892" class="d-block w-100" alt="...">
        </slide>

      </carousel>


<!--        <img src="https://firebasestorage.googleapis.com/v0/b/anton-von-heiseler.appspot.com/o/52.jpg?alt=media&token=1e0941ff-0beb-4486-9230-8d42e45fca92" class="img-fluid" alt="Responsive image">-->
        <p class="lead mt-4 mb-4">IGEL follows my grandmother through here daily routine and listens to her childhood memories.</p>
<!--        <div class='embed-container'><iframe src='https://www.youtube.com/embed/9K0C1MhU-Vw' frameborder='0' allowfullscreen></iframe></div>-->

      <p class="lead mt-5 mb-4">
        <span class="font-weight-normal">DIRECTOR |</span> Anton von Heiseler <br>
        <span class="font-weight-normal">CINEMATOGRAPHER |</span> Lena Renée Krenz <br>
        <span class="font-weight-normal">EDITOR |</span> Armarno Forster <br>
        <span class="font-weight-normal">SOUND |</span> Wenzel Krah <br>
      </p>
    </div>
</template>

<script>
    export default {
        name: "derigel"
    }
</script>

<style scoped>

</style>
